import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { progInfoConstants } from './program-info.constants';
import { ActivatedRoute, Params, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WhatToKnowUpComponent } from './what-to-know-up/what-to-know-up.component';
import { WhatToKnowNhComponent } from './what-to-know-nh/what-to-know-nh.component';
import { WhatToKnowShComponent } from './what-to-know-sh/what-to-know-sh.component';
import { WhatToKnowFastComponent } from './what-to-know-fast/what-to-know-fast.component';
import { AnalyticsService } from '../common/services/analytics.service';
import { ModalService } from '../shared/modals/modal.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

@Component({
  selector: 'app-program-information',
  templateUrl: './program-information.component.html',
  imports: [CommonModule, RouterModule, TranslateModule,
    WhatToKnowUpComponent, WhatToKnowNhComponent, WhatToKnowShComponent, WhatToKnowFastComponent],
  styleUrl: './program-information.component.scss'
})
export class ProgramInformationComponent implements OnInit {
 
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedProgram: any;
  selectedProgramCode ='';

  constructor(private route: ActivatedRoute,
              private analyticsService: AnalyticsService,
              private modalService: ModalService) {
  }
  
  ngOnInit(): void {

        this.route.queryParams.subscribe((params: Params) => {
          const code = params.code;

          this.setSelected(code);
        });
  }
  public TSA_LOGIN_URL = environment.tsaLoginURL;

  public logGetStartedProgram(programCode: string) {
    if (programCode) {
      this.analyticsService.logGetStarted(programCode).subscribe();
    }
  }

  public setSelected(progamCode: string) {
    this.selectedProgramCode = progamCode;
    switch (progamCode) {
      case 'UP' :
        this.selectedProgram = progInfoConstants.GLOBAL_ENTRY_INFO;
        break;
      case 'NH' :
        this.selectedProgram = progInfoConstants.NEXUS_INFO;
        break;
      case 'SH' :
        this.selectedProgram = progInfoConstants.SENTRI_INFO;
        break;
        case 'FS' :
        case 'FN' :
        case 'FAST' :
        this.selectedProgram = progInfoConstants.FAST_INFO;
        break;
      case 'TSA' :
        this.selectedProgram = progInfoConstants.TSA_INFO;
        break;            
      default:
        this.selectedProgramCode = 'UP';
        this.selectedProgram = progInfoConstants.GLOBAL_ENTRY_INFO;
    }
  }

  public getStarted(programCode: string) {

    if (programCode === 'UP') {
      this.modalService.considerTSA().then((res) => {
        if (res) {
          this.logGetStartedProgram(programCode);
          $('#security-warn').modal('show');
        }
      });
    } else {
      this.logGetStartedProgram(programCode);
      $('#security-warn').modal('show');
    }
  }
}
